import { useApolloClient, useMutation } from '@apollo/client/react';
import { isDefined } from 'app-shared/utils';
import { useCallback } from 'react';
import { SKIP_ERROR_TOAST_CONTEXT } from '@/apollo/constants/SkipErrorToastContext';
import {
  CancelInterventionDocument,
  GetInterventionsDocument,
  GetPlanningBoardDocument,
  type InterventionFieldsFragment,
} from '~/generated/graphql';
export const useCancelIntervention = () => {
  const client = useApolloClient();
  const [mutate] = useMutation(CancelInterventionDocument);
  const cancelIntervention = useCallback(
    async (id: string, version: number) => {
      let intervention: InterventionFieldsFragment | null = null;
      try {
        const { data, error } = await mutate({
          variables: { id, version },
          errorPolicy: 'all',
          context: SKIP_ERROR_TOAST_CONTEXT,
        });
        intervention = data?.cancelIntervention ?? null;
        if (!isDefined(intervention))
          return { intervention, error, refreshError: undefined };
        try {
          await client.refetchQueries({
            include: [GetInterventionsDocument, GetPlanningBoardDocument],
          });
          return { intervention, error, refreshError: undefined };
        } catch (refreshError) {
          return { intervention, error, refreshError };
        }
      } catch (error) {
        return { intervention, error, refreshError: undefined };
      }
    },
    [client, mutate],
  );
  return { cancelIntervention };
};
